import { TbasService } from '../services/tbas.services';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';

export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('billInfoEdit', {
    component: 'fizyPaycellBillInfoEdit',
    parent: 'buy',
    resolve: {
      invoice: [
        '$q',
        'tbasService',
        'globalSpinner',
        ($q, tbasService: TbasService, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return tbasService
            .getInvoiceAddressInfo()
            .catch((/*error*/) => $q.resolve())
            .finally(() => globalSpinner.stop());
        }
      ]
    },
    url: '/edit-bill'
  });

  $stateProvider.state('billInfoAdd', {
    component: 'fizyPaycellBillInfoAdd',
    parent: 'buy',
    url: '/add-bill'
  });
}



// WEBPACK FOOTER //
// ./src/app/buy/bill-info/bill-info-root.routes.ts